import React from "react";

const CATEGORY_LABELS = {
  mobile: "Mobile",
  web: "Web",
  game: "Game",
};

const HeroSpotlight = ({
  recentProjects,
  onExploreProjects,
  recentLaunchesLabel,
  metricsLabels,
  projectCount,
}) => (
  <aside className="hero-spotlight" aria-label="Developer highlights">
    <div className="hero-spotlight-glow" aria-hidden="true" />
    <div className="hero-spotlight-card">
      <div className="hero-spotlight-card-accent" aria-hidden="true" />

      <header className="hero-spotlight-profile">
        <div className="hero-spotlight-avatar" aria-hidden="true">
          <img
            src={`${process.env.PUBLIC_URL}/images/mokhles.png`}
            alt=""
            className="hero-spotlight-avatar-img"
          />
        </div>
        <div className="hero-spotlight-identity">
          <p className="hero-spotlight-label">Full Stack</p>
          <p className="hero-spotlight-role">
            Mobile <span className="hero-spotlight-role-accent">& Web</span>
          </p>
        </div>
      </header>

      <div className="hero-spotlight-metrics" role="list">
        <div className="hero-metric" role="listitem">
          <strong>5+</strong>
          <span>{metricsLabels.years}</span>
        </div>
        <div className="hero-metric" role="listitem">
          <strong>{projectCount}</strong>
          <span>{metricsLabels.projects}</span>
        </div>
        <div className="hero-metric" role="listitem">
          <strong>Live</strong>
          <span>{metricsLabels.stores}</span>
        </div>
      </div>

      {recentProjects?.length > 0 && (
        <div className="hero-spotlight-projects">
          <p className="hero-spotlight-projects-title">{recentLaunchesLabel}</p>
          <ul>
            {recentProjects.map((project) => {
              const isLive = project.status?.toLowerCase() === "live";

              return (
                <li key={project.title}>
                  <button
                    type="button"
                    className="hero-project-chip"
                    onClick={onExploreProjects}
                  >
                    <span className="hero-project-icon">{project.icon}</span>
                    <span className="hero-project-copy">
                      <span className="hero-project-name">{project.title}</span>
                      <span className="hero-project-meta">
                        <span>
                          {CATEGORY_LABELS[project.category] ||
                            project.category}
                        </span>
                        {isLive && (
                          <span className="hero-project-live">
                            <span
                              className="hero-project-live-dot"
                              aria-hidden="true"
                            />
                            Live
                          </span>
                        )}
                      </span>
                    </span>
                    <i
                      className="fas fa-arrow-right hero-project-arrow"
                      aria-hidden="true"
                    />
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  </aside>
);

export default HeroSpotlight;
